import React from 'react';
import Text from '@/components/Text';
import { SlideProps } from './slideTypes';
import { SLIDE_COMPONENT_TEXT_SIZE } from './slideConstants';

export function TableSlide({ slide }: SlideProps) {
  const headers = Array.isArray(slide.data?.headers) ? slide.data.headers : [];
  const rows = Array.isArray(slide.data?.rows) ? slide.data.rows : [];
  const hasTableContent = headers.length > 0 || rows.length > 0;
  
  if (!hasTableContent) return null;

  return (
    <div className="flex flex-col gap-3 md:gap-4 w-full px-4 md:px-6 py-6 md:py-8 items-start justify-center overflow-y-auto max-h-full">
      <div className="overflow-hidden rounded-xl border border-white/10 bg-black/20 backdrop-blur-sm w-full overflow-x-auto">
        <table className="w-full text-left border-collapse min-w-[300px]">
          <thead>
            <tr className="bg-white/5">
              {headers.map((header: any, index: number) => (
                <th key={index} className="p-2 md:p-4">
                  <Text size="xs" className="text-white font-normal uppercase tracking-widest text-left md:text-sm text-xs">
                    {String(header)}
                  </Text>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row: any, rowIndex: number) => (
              <tr key={rowIndex} className="border-b border-white/5 last:border-0">
                {Array.isArray(row) && row.map((cell: any, cellIndex: number) => (
                  <td key={cellIndex} className="p-2 md:p-4">
                    <Text size={SLIDE_COMPONENT_TEXT_SIZE} className="text-white/80 text-left text-xs md:text-md">
                      {String(cell)}
                    </Text>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
